import React from "react";
import PropTypes from "prop-types";

import style from "./Widget.module.css";
import SyntaxHighlight from "../../components/common/SyntaxHighlight";

class Widget extends React.Component {
  render() {
    const { widget } = this.props;

    return (
      <div className={style.root}>
        <div className={style.example}>
          <div className={style.demoRow}>
            <div className={style.box}>
              <div className={style.header}>{widget.name}</div>
              <div className={style.live}>
                <style dangerouslySetInnerHTML={{ __html: widget.outputCss }} />
                <style
                  dangerouslySetInnerHTML={{ __html: widget.utilOutputCss }}
                />
                <div dangerouslySetInnerHTML={{ __html: widget.html }} />
              </div>
            </div>
          </div>
          <div className={style.row}>
            <div className={style.column}>
              {widget.utilInputCss && (
                <div className={style.box}>
                  <div className={style.header}>util.css</div>
                  <SyntaxHighlight language="css" code={widget.utilInputCss} />
                </div>
              )}
              <div className={style.box}>
                <div className={style.header}>{widget.name}.css</div>
                <SyntaxHighlight language="css" code={widget.inputCss} />
              </div>
              <div className={style.box}>
                <div className={style.header}>Generated CSS</div>
                <SyntaxHighlight language="css" code={widget.outputCss} />
              </div>
            </div>
            <div className={style.column}>
              <div className={style.box}>
                <div className={style.header}>{widget.name}.js</div>
                <SyntaxHighlight language="jsx" code={widget.component} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
Widget.propTypes = {
  widget: PropTypes.shape({
    name: PropTypes.string,
    inputCss: PropTypes.string,
    outputCss: PropTypes.string,
    outputJs: PropTypes.string,
    component: PropTypes.string,
    html: PropTypes.string
  }).isRequired
};
export default Widget;



// WEBPACK FOOTER //
// ./src/guides/css-modules-by-example/Widget.js